var exports = {
  "p": "ChannelWelcomeSection.module__channelIcon___V0luTU",
  "kL": "ChannelWelcomeSection.module__container___V0luTU",
  "R_": "ChannelWelcomeSection.module__heading___V0luTU",
  "h_": "ChannelWelcomeSection.module__description___V0luTU",
  "RK": "ChannelWelcomeSection.module__iconSize___V0luTU",
};

module.exports = exports;
